@if (personaForm) {
  <form [formGroup]="personaForm">
    @if (personaQuestionsAnswersEnabled && personaQuestionsAndAnswersData?.length > 0) {
      <div
        class="container-fluid p-0">
        @if (title && description) {
          <yc-panel
            [type]="panelType"
            [isFirst]="isFirst"
            [title]="title"
            [description]="description">
          </yc-panel>
        }
        @if (descriptionForComponentInModalUse) {
          <div>
            <span>{{descriptionForComponentInModalUse}}</span>
            <br>
              <br>
              </div>
            }
            @for (questionInfo of personaQuestionsAndAnswersData; track questionInfo) {
              <div>
                <yc-typeahead-select
                  name="systemQuestion{{questionInfo.personaQuestionsAndAnswers.systemQuestionId}}"
                  [items]="questionInfo.formFieldSelectOptions"
                  [label]="questionInfo.personaQuestionsAndAnswers.translationText"
                  [description]="questionInfo.personaQuestionsAndAnswers?.descriptionTranslationText"
                  [multi]="questionInfo.personaQuestionsAndAnswers.allowsMultipleResponses"
                  [addRequiredAsterisk]="unansweredQuestionsOnly || questionInfo.personaQuestionsAndAnswers.requiresAnswer  ? true : false"
                  [showClear]="false"
                  [showSelectAllThatApplyHelpText]="questionInfo.personaQuestionsAndAnswers.allowsMultipleResponses ? true : false"
                  [useLabelTemplate]="false"
                  (onChange)="onAnswerUpdate($event, questionInfo.personaQuestionsAndAnswers, questionInfo.personaUserAnswers)">
                </yc-typeahead-select>
                @if (questionInfo.customResponseForQuestion) {
                  <div>
                    <span>
                      <span>
                        <yc-i18n key="account:personaCustomResponse" defaultValue="Other:"></yc-i18n> {{questionInfo.customResponseForQuestion}}
                      </span>
                      @if (!viewOnly) {
                        <span>
                          <!-- Edit Response option -->
                          <yc-button
                            class="action"
                            [icon]="true"
                            (onClick)="editCustomResponsePersonaAnswer(questionInfo.systemAnswerIdForCustomResponse, questionInfo.userSystemAnswerIdForCustomResponse, questionInfo.customResponseForQuestion, questionInfo.personaUserAnswers)"
                            [tooltipText]="'account:btnEditResponse' | ycI18n: 'Edit Response'">
                            <yc-fa class="text-info" icon="pencil"></yc-fa>
                          </yc-button>
                        </span>
                      }
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </form>
    }